"use strict";
/**
 * Created on 10 23 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");
/**
 * Represents state of process of calculation of prices.
 *
 * @author JGr
 * @author JMe (added desc and FINISHED_WITH_ERROR)
 */


var ReleasePriceCalculationState;

(function (ReleasePriceCalculationState) {
  /** A process of a calculation is still running. */
  ReleasePriceCalculationState["PENDING"] = "PENDING";
  /** A process of a calculation has finished with success. */

  ReleasePriceCalculationState["FINISHED"] = "FINISHED";
  /** A process of a calculation has finished with an error. */

  ReleasePriceCalculationState["FAILED"] = "FAILED";
  /**
   * <p>A process of a calculation has finished with an error but process may be potentially handled using some fallback way -> we
   * consider result of a calculation as empty and this state as some kind of 'FINISHED'.</p>
   *
   * <p><b>Unlike others, this state is intended to be used for only special cases (see LOG-7623 for an example of usages).</b></p>
   */

  ReleasePriceCalculationState["FINISHED_WITH_ERROR"] = "FINISHED_WITH_ERROR";
})(ReleasePriceCalculationState = exports.ReleasePriceCalculationState || (exports.ReleasePriceCalculationState = {}));
/**
 * @author JGr
 */


var ReleasePriceCalculationStateUtil =
/*#__PURE__*/
function () {
  function ReleasePriceCalculationStateUtil() {
    _classCallCheck(this, ReleasePriceCalculationStateUtil);
  }

  _createClass(ReleasePriceCalculationStateUtil, null, [{
    key: "aggregate",
    value: function aggregate(states) {
      if (states.some(function (s) {
        return s === ReleasePriceCalculationState.PENDING;
      })) {
        return ReleasePriceCalculationState.PENDING;
      } else if (states.every(function (s) {
        return ReleasePriceCalculationStateUtil.FINISHED_AGG_STATES.has(s);
      })) {
        return ReleasePriceCalculationState.FINISHED;
      } else {
        return ReleasePriceCalculationState.FAILED;
      }
    }
  }]);

  return ReleasePriceCalculationStateUtil;
}();

exports.ReleasePriceCalculationStateUtil = ReleasePriceCalculationStateUtil;
ReleasePriceCalculationStateUtil.FINISHED_AGG_STATES = immutable_1.Set.of(ReleasePriceCalculationState.FINISHED, ReleasePriceCalculationState.FINISHED_WITH_ERROR);